import React from 'react';

interface Props {}

interface State {
  showAllText: any;
}

class CollapseMobile extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showAllText: false,
    };
  }

  handleOnClick = () => {
    this.setState({ showAllText: !this.state.showAllText });
  };

  render() {
    const { showAllText } = this.state;
    return (
      <span className={`collapse-container-mobile`}>
        {!showAllText ? (
          <span onClick={this.handleOnClick} className="read-more-m color-b">
            Read More
          </span>
        ) : (
          <span className="dispaly-none">
            {this.props.children}
            <span onClick={this.handleOnClick} className="read-less-m color-b">
              Read Less
            </span>
          </span>
        )}
      </span>
    );
  }
}
export default CollapseMobile;
